import React from 'react';
import { Col, Form as FormComponent, FormGroup } from 'reactstrap';
import InputComponent from './Input';
import SelectComponent from './Select';

const components = {
  input: InputComponent,
  select: SelectComponent,
};

const getComponent = (type) => components[type];

const Form = (props) => {
  const { form, onChange, localValue, validate, invalidate, children } = props;

  const onChangeCore = (name) => (v) => onChange(name, v);

  return (
    <FormComponent>
      {form.map((fromItem) => {
        const { component, prop, ...rest } = fromItem;
        const Component = getComponent(component);
        return (
          <Col lg="12" key={prop}>
            <FormGroup className="position-relative">
              <Component
                prop={prop}
                {...rest}
                value={localValue[prop]}
                valid={validate[prop]}
                invalid={invalidate[prop]}
                onChange={onChangeCore(prop)}
              />
            </FormGroup>
          </Col>
        );
      })}
      {children}
    </FormComponent>
  );
};

export default Form;
